export default {
  isUserLoggedIn: () => localStorage.getItem('accessToken'),
}
